<template>
  <div class="account-wrap">
    <div class="seletc-list">
      <el-select
        v-model="filterData.productIds"
        filterable
        multiple
        collapse-tags
        style="width: 350px"
        clearable
        placeholder="选择产品"
        @change="clickSearch"
      >
        <el-option
          v-for="item of appList"
          :key="item.app_cloud_id"
          :label="item.app_name + '（' + item.package_name + '）'"
          :value="item.app_cloud_id"
        >
        </el-option>
      </el-select>
      <el-select
        style="width: 200px; margin-left: 24px"
        v-model="filterData.userIds"
        multiple
        collapse-tags
        placeholder="选择优化师"
        clearable
        @change="clickSearch"
      >
        <el-option v-for="item of optimizerList" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <el-select
        style="width: 160px; margin-left: 24px"
        v-model="filterData.status"
        placeholder="选择用户状态"
        @change="clickSearch"
      >
        <el-option label="全部状态" :value="-1"> </el-option>
        <el-option label="已授权" :value="1"> </el-option>
        <el-option label="未授权" :value="0"> </el-option>
      </el-select>
      <el-date-picker
        class="data-range"
        v-model="filterData.time"
        type="daterange"
        range-separator="→"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        style="width: 240px; margin-left: 24px"
        value-format="yyyy-MM-dd"
        :clearable="false"
        @change="clickSearch"
      >
      </el-date-picker>
    </div>
    <div class="content-wrap">
      <div class="btn-list">
        <el-select
          v-model="filterData.advertiserIds"
          filterable
          multiple
          collapse-tags
          style="width: 350px"
          clearable
          placeholder="请选择广告账号"
          @change="clickSearch"
        >
          <el-option
            v-for="item of accountList"
            :key="item.advertiserId"
            :label="item.company + '（' + item.advertiserId + '）'"
            :value="item.advertiserId"
          >
          </el-option>
        </el-select>
        <el-popover placement="bottom" width="238" trigger="click" v-model="showPlBox">
          <div class="edit-budget-wrap">
            <el-form :model="budgetData" :rules="budgetRules" ref="budgetFormRef">
              <span style="font-size: 14px; color: rgba(0, 0, 0, 0.65)">预算：</span>
              <el-radio-group v-model="budgetData.budget_mode">
                <el-radio label="BUDGET_MODE_INFINITE">不限</el-radio>
                <el-radio label="BUDGET_MODE_DAY">指定预算</el-radio>
              </el-radio-group>
              <div class="input-wrap" v-show="budgetData.budget_mode === 'BUDGET_MODE_DAY'">
                <el-form-item prop="budget">
                  <el-input
                    style="margin-top: 10px"
                    placeholder="请输入预算日"
                    v-model="budgetData.budget"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="button-wrap" style="text-align: right; margin-top: 16px">
                <el-button style="height: 26px" size="mini" @click="showPlBox = false"
                  >取消</el-button
                >
                <el-button style="height: 26px" size="mini" type="primary" @click="editBudget"
                  >确定</el-button
                >
              </div>
            </el-form>
          </div>
          <template slot="reference">
            <!-- <el-button class="top-btn">
              <i class="el-icon-edit"></i>
              修改预算</el-button
            > -->
          </template>
        </el-popover>
        <!-- 选择字段弹框 -->
        <select-field
          :options="fieldOptions"
          :staticOptions="staticOptions"
          @changeColumn="generateCols"
          :type="1"
          :platType="2"
          style="margin-left: auto"
        ></select-field>
        <el-button
          class="top-btn"
          icon="el-icon-refresh"
          style="margin-left: 16px"
          @click="asyncData"
          >刷新数据</el-button
        >
        <el-button
          class="top-btn"
          icon="el-icon-download"
          @click="downloadReport"
          :loading="downloadLoading"
          >下载报表</el-button
        >
      </div>
      <div class="table-wrap">
        <el-table
          @selection-change="handleSelectionChange"
          :data="tableList"
          :max-height="tableMaxHeight"
          v-loading="loading"
        >
          <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
          <el-table-column
            v-for="item of staticOptions"
            :key="item.value"
            :prop="item.value"
            :label="item.label"
            :min-width="item.width"
            :fixed="true"
          >
          </el-table-column>
          <el-table-column
            v-for="item of tableCols"
            :key="item.value"
            :prop="item.value"
            :label="item.label"
            :min-width="item.width"
            :fixed="item.fixed"
          >
            <template slot-scope="scope">
              <!-- 预算 -->
              <div v-if="item.value === 'budget'">
                <div>
                  {{
                    scope.row.budget_mode === "BUDGET_MODE_INFINITE"
                      ? "不限"
                      : scope.row.budget_mode === "BUDGET_MODE_DAY"
                      ? "统一预算"
                      : scope.row.budget_mode === "BUDGET_MODE_DAY_SCHEDULE"
                      ? "分日预算"
                      : "-"
                  }}
                  <i
                    class="el-icon-edit"
                    style="cursor: pointer"
                    v-if="scope.row.budget_mode"
                    @click="editBudget(scope.row)"
                  ></i>
                </div>
                <div v-if="scope.row.budget_mode === 'BUDGET_MODE_DAY_SCHEDULE'">
                  <el-tooltip placement="top">
                    <div slot="content">
                      {{ "星期一 " + scope.row.dayBudgetSchedule[0] + " CNY" }}<br />
                      {{ "星期二 " + scope.row.dayBudgetSchedule[1] + " CNY" }}<br />
                      {{ " 星期三 " + scope.row.dayBudgetSchedule[2] + " CNY" }}<br />
                      {{ "星期四 " + scope.row.dayBudgetSchedule[3] + " CNY" }}<br />
                      {{ "星期五 " + scope.row.dayBudgetSchedule[4] + " CNY" }}<br />
                      {{ "星期六 " + scope.row.dayBudgetSchedule[5] + " CNY" }}<br />
                      {{ "星期日 " + scope.row.dayBudgetSchedule[6] + " CNY" }}<br />
                    </div>
                    <div class="day_budget_wrap">
                      {{ scope.row.dayBudgetSchedule.join("、") }}
                    </div>
                  </el-tooltip>
                </div>
                <div v-else-if="scope.row.budget_mode === 'BUDGET_MODE_DAY'">
                  {{ scope.row.budget + " CNY" }}
                </div>
              </div>
              <span v-else>
                {{ scope.row[item.value] === null ? "--" : scope.row[item.value] }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="操作" fixed="right" width="180">
            <template slot-scope="scope">
              <el-button type="text" @click="checkPlan(scope.row)">查看计划</el-button>
              <el-button type="text" @click="checkAdGroup(scope.row)">查看广告组</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page-wrap">
        <self-pagination
          :total="pageData.total"
          :pageSize="pageData.size"
          :currentPage="pageData.page"
          ref="tabelPagination"
          @getCurrentPage="changePage"
          @handleSizeChange="changePageSize"
        ></self-pagination>
      </div>
    </div>

    <!-- 预算修改弹框 -->
    <budget-modal
      ref="budgetModalRef"
      tableType="adCount"
      @refreshData="clickSearch()"
    ></budget-modal>
  </div>
</template>

<script>
import SelectField from "@/components/selectField.vue";
import BudgetModal from "../common/budgetModal.vue";
import { attribute, baseData, appData } from "@/config/fieldData_gdt";
import {
  getAdCountList_gdt,
  getDesigner,
  queryAdvertiserData_gdt,
  refreshReportData_gdt,
} from "@/api/promotionReport.js";
import { getCommonProductList } from "@/api/api.js";
import { downLoadWrokSheet } from "@/utils/commonTools.js";
import { formatTableList } from "../formatData.js";
import moment from "moment";
export default {
  name: "AccountTable",
  components: {
    SelectField,
    BudgetModal,
  },
  data() {
    return {
      loading: false,
      appList: [],
      optimizerList: [],
      accountList: [],
      filterData: {
        productIds: [],
        userIds: [],
        status: -1,
        time: [
          moment().subtract(7, "days").format("YYYY-MM-DD"),
          moment().subtract(1, "days").format("YYYY-MM-DD"),
        ],
        advertiserIds: [],
      },
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      fieldOptions: [
        { title: "属性数据", list: attribute.account },
        { title: "基础数据", list: baseData },
        { title: "应用数据", list: appData },
      ],
      staticOptions: [
        { label: "广告账户ID", value: "advertiserId", width: "180" },
        { label: "广告账户名称", value: "advertiserName", width: "180" },
      ],
      tableList: [],
      tableCols: [],
      tableMaxHeight: window.innerHeight - 345,
      showPlBox: false,
      budgetData: {
        budget_mode: "BUDGET_MODE_DAY",
        budget: "",
      },
      budgetRules: {
        budget: [
          {
            validator: (rule, value, callback) => {
              if (this.budgetData.budget_mode === "BUDGET_MODE_DAY") {
                let data = parseFloat(this.budgetData.budget);
                if (data >= 300) {
                  callback();
                } else {
                  callback(new Error("请输入不小于300的数字"));
                }
              } else {
                callback();
              }
            },
            trigger: ["blur", "change"],
          },
        ],
      },
      checkedList: [],
      downloadLoading: false,
      timer: null,
    };
  },
  mounted() {
    this.initSelectOptions();
    this.clickSearch();
  },
  methods: {
    handleSelectionChange(e) {
      if (e.length > 0) {
        this.showPlBox = true;
      } else {
        this.showPlBox = false;
      }
      this.checkedList = e;
    },
    initSelectOptions() {
      getCommonProductList({
        platType: 2,
      }).then((res) => {
        if (res.code === "0000") {
          this.appList = res.data;
        }
      });
      getAdCountList_gdt({
        platType: 2,
      }).then((res) => {
        if (res.code === "0000") {
          this.accountList = res.advertiseInfos;
        }
      });
      getDesigner().then((res) => {
        if (res.code === "0000") {
          this.optimizerList = res.tags;
        }
      });
    },
    clickSearch() {
      this.pageData.page = 1;
      this.$refs.tabelPagination.currentPage = 1;
      this.searchData();
    },
    formatData() {
      let parmas = {
        pageNum: this.pageData.page,
        pageSize: this.pageData.size,
        startTime: this.filterData.time[0],
        endTime: this.filterData.time[1],
      };
      for (let key in this.filterData) {
        let checkData = this.filterData[key];
        if (checkData === "" || checkData === -1 || key === "time") {
          continue;
        }
        if (Array.isArray(checkData)) {
          checkData.length > 0 && (parmas[key] = checkData);
        } else {
          parmas[key] = checkData;
        }
      }
      return parmas;
    },
    formatTableData(list) {
      return list.map((item) => {
        item.status = item.status == 1 ? "已授权" : "未授权";
        formatTableList(item);
        return item;
      });
    },
    searchData() {
      let parmas = this.formatData();
      this.loading = true;
      queryAdvertiserData_gdt(parmas).then((res) => {
        this.loading = false;
        const { list, total } = res.data;
        if (res.code === "0000") {
          this.tableList = this.formatTableData(list || []);
          this.pageData.total = total;
        }
      });
    },
    generateCols(colData) {
      if (colData.custom.concat(colData.fixed).length === 0) {
        //赋值默认表格列
        colData.custom = [
          "appName",
          "status",
          "optimizer",
          "balance",
          "dailyBudget",
          "showCnt",
          "clickCnt",
          "ctr",
          "cpc",
          "thousandDisplayPrice",
          "cost",
        ];
      }
      let allFieldsMap = attribute.account.concat(baseData, appData); //所有列
      let tableCols = [];
      colData.fixed.forEach((item) => {
        let findItem = allFieldsMap.find((colItem) => colItem.value === item);
        if (findItem) {
          let tabelcolItem = { fixed: true, width: "120" };
          tableCols.push(Object.assign(tabelcolItem, findItem));
        }
      });
      colData.custom.forEach((item) => {
        let findItem = allFieldsMap.find((colItem) => colItem.value === item);
        if (findItem) {
          let tabelcolItem = { fixed: undefined, width: "120" };
          tableCols.push(Object.assign(tabelcolItem, findItem));
        }
      });
      this.tableCols = [];
      this.$nextTick(() => {
        this.tableCols = tableCols;
      });
    },
    changePage(page) {
      this.pageData.page = page;
      this.searchData();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.searchData();
    },
    downloadReport() {
      this.downloadLoading = true;
      let parmas = this.formatData();
      delete parmas.page;
      delete parmas.size;
      queryAdvertiserData_gdt(parmas).then((res) => {
        this.downloadLoading = false;
        if (res.code === "0000") {
          const dataList = this.formatTableData(res.data.list || []);
          //表头映射
          const HeaderData = {};
          this.staticOptions.concat(this.tableCols).forEach((item) => {
            HeaderData[item.value] = item.label;
          });
          downLoadWrokSheet(dataList, "投放账号.xlsx", HeaderData);
        }
      });
    },
    checkAdGroup(rowData) {
      this.$emit("checkTable", {
        name: "GroupTable",
        data: Object.assign({}, rowData, { time: this.filterData.time }),
      });
    },
    checkPlan(rowData) {
      this.$emit("checkTable", {
        name: "PlanTable",
        data: Object.assign({}, rowData, { time: this.filterData.time }),
      });
    },
    //批量修改预算
    editBudget(rowData) {
      this.$refs.budgetModalRef.showModal(rowData);
    },
    inputSearch() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.clickSearch();
      }, 500);
    },
    asyncData() {
      refreshReportData_gdt({ level: "REPORT_LEVEL_ADVERTISER" }).then(() => {});
      this.$message({
        message: "数据同步中，预计半小时同步成功",
        type: "success",
      });
    },
  },
};
</script>

<style lang="less" scoped>
.account-wrap {
  .seletc-list {
    display: flex;
    align-items: center;
    padding: 15px 24px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.08);
    .data-range {
      position: relative;
      /deep/.el-range__icon {
        position: absolute;
        right: 6px;
        top: 0px;
      }
      /deep/.el-range-separator {
        line-height: 24px;
        color: rgba(0, 0, 0, 0.25);
      }
    }
    .wenhao-icon {
      margin-left: 12px;
      cursor: pointer;
    }
    .submit-btn {
      margin-left: auto;
      padding: 0 20px;
    }
  }
  .content-wrap {
    margin-top: 16px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 16px 24px;
    .btn-list {
      display: flex;
      align-items: center;
      height: 45px;
      .top-btn {
        color: rgba(24, 144, 255, 1);
        font-size: 14px;
        border-radius: 2px;
        border: 1px solid rgba(24, 144, 255, 1);
        background: rgba(255, 255, 255, 1);
        .pl-icon {
          margin-right: 8px;
        }
      }
      .search-input {
        width: 160px;
        margin-right: 24px;
        /deep/ .el-input__icon {
          line-height: 35px;
        }
      }
    }
    .table-wrap {
      margin-top: 16px;
      .status {
        display: flex;
        align-items: center;
        &::before {
          content: "";
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          margin-right: 4px;
        }
        &.start::before {
          background: rgba(30, 194, 57, 1);
        }
        &.stop::before {
          background: rgba(235, 49, 49, 1);
        }
      }
      .day_budget_wrap {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .page-wrap {
    }
  }
}
</style>
